// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"dynamic4footerComment":"7d46e0","dynamic4channelEntry":"1ae497","dynamic4navLayercss":"c84c6c","article-insert":"93c9bb"}[chunkId] + ".css";
};